import React from 'react'
import { Button } from 'components/UIElements'
import { INSTRUMENT_TYPES_WITH_TRANSLATIONS } from 'utils/constants'
import InstrumentsViewExportButton from './InstrumentsViewExportButton'
import InstrumentsViewDefaultButtons from './InstrumentsViewDefaultButtons'
import useInstrumentUnificationFeature from 'utils/hooks/useInstrumentUnificationFeature'

const InstrumentsViewButtonList = ({
  canWrite,
  ids,
  onDelete,
  onOpenUploadModal,
  onDownloadTranslations,
  onDownloadJSONs,
  hasClinro,
  hasDiary,
  openModal,
  studyLock,
  updateWizardTitle,
  updateWizardDisplayName,
  wizardTitle,
  wizardDisplayName,
  checked,
  study,
  userId,
  isReadOnlyState,
  studyVersionID,
  isDeleting = false,
}) => {
  const { id: studyID } = study

  const { hasInstrumentUnification } = useInstrumentUnificationFeature({ study, userId })

  if (ids.length === 0)
    return (
      <InstrumentsViewDefaultButtons
        canWrite={canWrite}
        hasClinro={hasClinro}
        hasDiary={hasDiary}
        openModal={openModal}
        studyID={studyID}
        studyLock={studyLock}
        updateWizardTitle={updateWizardTitle}
        updateWizardDisplayName={updateWizardDisplayName}
        wizardTitle={wizardTitle}
        wizardDisplayName={wizardDisplayName}
        hasInstrumentUnification={hasInstrumentUnification}
        isReadOnlyState={isReadOnlyState}
        studyVersionID={studyVersionID}
      />
    )

  const onlyTypesWithTranslationsChecked = ids.every(id =>
    INSTRUMENT_TYPES_WITH_TRANSLATIONS.includes(checked[id].type),
  )

  const buttons = []

  if (canWrite) {
    if (!isReadOnlyState) {
      buttons.push(
        <Button
          key='delete'
          grey
          id='delete-instrument'
          content={isDeleting ? 'Deleting instrument…' : 'Delete'}
          disabled={isDeleting}
          onClick={onDelete()}
        />,
      )
    }
    if (onlyTypesWithTranslationsChecked && ids.length === 1) {
      buttons.push(
        <Button
          key='upload'
          grey
          id='upload-csv-translation'
          content='Upload CSV with Translation'
          onClick={onOpenUploadModal}
        />,
      )
    }
  }

  if (onlyTypesWithTranslationsChecked)
    buttons.push(
      <InstrumentsViewExportButton
        showTranslationButton={ids?.length > 0}
        onDownloadTranslations={onDownloadTranslations}
        onDownloadJSONs={onDownloadJSONs}
      />,
    )

  return <div className='header-button-list'>{buttons}</div>
}

export default InstrumentsViewButtonList
